import { Component } from '@angular/core';

@Component({
  selector: 'allas-servicio-profesional',
  imports: [],
  template: `<section class="flex flex-col xl:flex-row mt-12 mb-12">
    <div
      class="bg-[#f3f4f6] p-6 xl:p-12 flex flex-col items-center justify-center flex-auto h-[400px] xl:h-[500px] order-2 xl:order-0"
    >
      <main class="flex flex-col items-center xl:items-start">
        <h3 class="text-4xl xl:text-6xl font-bold fs-condensed text-appBlack">
          SERVICIO
        </h3>
        <h2 class="text-4xl xl:text-6xl font-bold fs-condensed text-appBlack">
          PROFESIONAL
        </h2>
        <h1
          class="text-5xl xl:text-7xl font-bold fs-condensed text-appPrimary-500"
        >
          GARANTIZADO
        </h1>
        <p class="text-appBlack xl:text-xl mt-4 text-center xl:text-left">
          Nuestros técnicos especializados <br />
          cuentan con la experiencia y <br />
          herramientas necesarias para realizar <br />
          el cambio de filtros de manera <br />
          profesional y eficiente
        </p>
      </main>
    </div>
    <div class="h-auto xl:h-[500px] order-1 xl:order-0">
      <img
        src="/images/services/cambio-filtros/ambos-filtros.webp"
        alt="ambos-filtros"
        class="h-full w-auto object-cover"
      />
    </div>
  </section>`,
})
export class ServicioProfesional {}
